import { cva } from 'class-variance-authority';

export const dialog = cva([
  'rounded-6',
  'shadow-1',
  'bg-grayscale0',
  'p-16',
  'flex',
  'flex-col',
  'gap-y-4',
  'max-w-124',
  'min-w-[212px]',
  'border',
  'border-grayscale100',
]);
